import { Icon } from '@/new/components/icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';

const OCR_REVIEW_THRESHOLD = 30;

export const SourceConfidenceWarning = ({ sourceConfidence }: { sourceConfidence?: number }) => {
  if (sourceConfidence == null || Math.round(sourceConfidence) >= OCR_REVIEW_THRESHOLD) return null;

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger>
        <div className="flex items-center gap-1.25 rounded-full border border-amber-300 bg-amber-50 px-1.5 py-0.5 pr-2 text-[11px] text-amber-600">
          <Icon className="lucide--alert-circle text-amber-500" />
          <p className="">Review text extraction</p>
        </div>
      </TooltipTrigger>
      <TooltipContent side="top">
        We detected anomalies when parsing this source. Please verify extracted content.
      </TooltipContent>
    </Tooltip>
  );
};
